import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Project } from '@shared/models/project.model';
import { BaseComponent } from '@shared/components/base.component';
import { Response } from '@shared/models/response.model';
import { RoutesPath } from '@shared/routes-path';
import { ProjectsService } from '../../layouts/guest/pages/projects/projects.service';
import { Router } from '@angular/router';
import { ProjectStatus } from '@shared/interfaces/project/project.interface';
import { DatetimeService } from '@shared/services/datetime.service';

@Component({
  selector: 'app-project-box',
  templateUrl: './project-box.component.html',
  styleUrls: ['./project-box.component.scss'],
})
export class ProjectBoxComponent extends BaseComponent implements OnDestroy, OnChanges {
  @Input() project: Project;
  enumProjectStatus = ProjectStatus;
  @Output() deleteModalSuccess: EventEmitter<void> = new EventEmitter();
  @Input() layout = 'grid';
  @Input() helpukraine = false;
  projectEndDaysLeft = 0;

  displaydeleteModalDraft: boolean = false;

  constructor(
    public projectsService: ProjectsService,
    public router: Router,
    public dateTimeService: DatetimeService
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.someSubscriptions.unsubscribe();
  }

  goToEdit(event) {
    event.preventDefault();
    event.stopPropagation();
    const defaultRoute = RoutesPath.default;

    const ua = this.project.categories.findIndex((i) => i.slug === 'helpukraine');

    if (ua > -1 && this.project.categories.length === 1) {
      this.router.navigate([`/${defaultRoute.help_ukraine_request}/edit/${this.project.id}`]);
      return;
    }

    this.router.navigate(['/' + defaultRoute.project_edit + '/' + this.project.id]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['project']) {
      this.helpukraine = this.project.categories.find((ua) => ua.id === 30) ? true : false;
      this.projectEndDaysLeft = this.project.closed_at
        ? 0
        : parseInt(this.dateTimeService.getProjectEndDaysLeft(this.project));
    }
  }

  projectOnList(ids: Array<number>) {
    return !!ids.filter((id) => this.project.id === id).length;
  }

  projectDeleteDraft() {
    const subDeleteDraftProject = this.projectsService
      .deleteDraftProject(this.project.id)
      .subscribe((el: Response<Project>) => {
        this.toast.success(
          this.translate.instant('PROJECT.project_success'),
          this.translate.instant('PROJECT.project_deleted')
        );
        this.closeDeleteModalDraft();
        this.deleteModalSuccess.emit();
      }, this.onEndProjectError.bind(this));
    this.someSubscriptions.add(subDeleteDraftProject);
  }

  onEndProjectError(error: Error) {
    if (error?.message === 'project_not_accepted') {
      this.toast.error(
        this.translate.instant('PROJECT.project_error'),
        this.translate.instant('PROJECT.end_project_cant_not_accepted')
      );
    } else {
      this.toast.error(
        this.translate.instant('PROJECT.project_error'),
        this.translate.instant('PROJECT.not_success_end_project')
      );
    }
  }

  containHelpUkraineTag() {
    return this.project.categories.some((r) => r.id === 30);
  }

  public closeDeleteModalDraft(): void {
    this.displaydeleteModalDraft = false;
  }

  public openDeleteModalDraft(event): void {
    event.preventDefault();
    event.stopPropagation();
    this.displaydeleteModalDraft = true;
  }
}
